import { getMessages } from '../../../../../store/constants';

export const NOTIFY_BUTTON = getMessages().getText('notify.button.title');

export enum NOTIFY_SELECT_GROUP {
    BOARD = 'BOARD',
    OTHER = 'OTHER',
}
